// extracted by mini-css-extract-plugin
export default {"main":"Faq_main__2GsVG","item":"Faq_item__3wj1j","title":"Faq_title__6201P","question":"Faq_question__+vFtX","container":"Faq_container__WQvvm"};